export const desktopOnlyFunction =
  (callback) =>
  (...params) =>
    window.innerWidth < 1024 ? undefined : callback(...params);

export const mobileOnlyFunction =
  (callback) =>
  (...params) =>
    window.innerWidth >= 1024 ? undefined : callback(...params);
